import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';

import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import teamWorkImage from 'assets/images/nutrition-cap60.jpeg';
import styles from './programs.module.scss';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
const REPORT_DATA = [
  {
    title: '',
    items: ['Service Details', 'VClient Listing', 'Volunteer Tracking      '],
  },
];

const FEATURE_DATA = [
  {
    id: '01',
    title: 'Track Consumable Goods',
  },
  {
    id: '02',
    title: 'Set Re-order Levels ',
  },
  {
    id: '03',
    title: 'Barcode Enabled Processing',
  },
];
function Nutrition() {
  return (
    <div>
      <Helmet>
        <title>Nutrition - CAP60</title>
        <meta
          name="description"
          content="With CAP60’s flexible interface, food programs of all types can confidently track and report on all related data. Call us Now!"
        />
        <meta name="keywords" content="contact us, cap60 contact" />
      </Helmet>
      <PageBanner
        title="Nutrition"
        subtitle="Accurate inventory control & quick service tracking
        "
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <CommunityServices />
        </Container>
      </div>
      <SampleReport data={REPORT_DATA} title="Reports" />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="primary"
            title="Features"
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
          />
        </Container>
      </div>
    </div>
  );
}
//
function CommunityServices() {
  return (
    <div className={styles.communityServicesWrap}>
      <Row className="align-items-center">
        <Col md="5">
          <Image src={teamWorkImage} fluid className="p-3 mb-4 mb-md-0" />
        </Col>
        <Col md="7">
          <div className="heading">
            <h2>Accurate inventory control & quick service tracking</h2>
          </div>
          <p>
            With CAP60’s flexible interface, food programs of all types can
            confidently track and report on all related data. Whether your
            agency hosts a multi-site food bank, or refers to a nearby food
            pantry partner, we have you covered.
          </p>

          <RequestDemoButton />
        </Col>
      </Row>
    </div>
  );
}

function SampleReport({ data, title }) {
  return (
    <div className={styles.sampleReportWrapper}>
      <Container>
        <div className="heading">{!!title && <h2> {title}</h2>}</div>
        <Row>
          {data.map((rdata, idx) => (
            <Col md="6" key={idx}>
              <div className={styles.reportList}>
                <h3>{rdata.title}</h3>
                <ul>
                  {rdata.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
export default Nutrition;
